/* eslint-disable func-names */
/* eslint-disable arrow-parens */
class FilterableFilterClass {
  init(type, filterable) {
    this.timeout = 15;
    this.defaultOptions = {
      config: {},
      valueCheckboxes: {},
      valueSelects: {},
      page: 0,
    };
    this.$filterable = $(filterable);
    this.type = type;
    this.localStorageItem = `${type}FilterableConfig`;
    this.$form = $(this.$filterable).find('form');
    this.$menu = this.$form.find('[data-filterable-menu]');
    this.$filterOptions = this.$form.find('ol.inputs-list input[type=checkbox], ol.inputs-list input[type=radio]');
    this.$filterSelects = this.$form.find('.filterable-selectbox select');
    this.$filterReset = this.$form.find('.filterable--reset');
    this.url = `${window.location.href}${this.type}.html`;

    const data = this.load();

    this.setupUi();

    /* checked checkboxes */
    $.each(data.valueCheckboxes, (key, val) => {
      $(`#${key}`).prop('checked', val);
    });

    $.each(data.valueSelects, (key, val) => {
      $(`#${key}`).val(val);
    });

    /* opened filter menus */
    // eslint-disable-next-line func-names, prefer-arrow-callback
    $.each(data.config, function (key, val) {
      $(`[data-filterable-menu=${key}]`).click();
      // $(`[data-filterable-menu=${val}]`).next()
      //   .show();
    });

    this.apply();
  }

  load() {
    let data = JSON.parse(localStorage.getItem(this.localStorageItem)) || this.defaultOptions;

    if ({}.hasOwnProperty.call(data, 'timestamp')) {
      data.timestamp = new Date(data.timestamp);
    } else {
      data.timestamp = new Date();
    }

    if (!this.isValid(data)) {
      localStorage.removeItem(this.localStorageItem);
      data = this.defaultOptions;
    }

    return data;
  }

  save(data) {
    const storage = data;
    storage.timestamp = new Date();
    localStorage.setItem(this.localStorageItem, JSON.stringify(storage));
  }

  /**
   * toggler management
   */
  setupUi() {
    this.toggleMenus();
    this.manageCheckboxes();
    this.manageSelectboxes();

    this.$filterReset.on('click', () => this.reset());
  }

  apply() {
    const data = this.load();

    $('input[data-toggle]').each(function () {
      if ($(this).data('toggle')) {
        const toggleKey = $(this).data('toggle');

        if ($(this).prop('checked')) {
          $(`#${toggleKey}`).show();
        } else {
          $(`#${toggleKey}`).hide();
        }
      }
    });

    /* UI controls */
    const formdata = $(this.$form).serialize();

    $.post(this.url, formdata, result => {
      const html = $(result)
        .find('.filterable--results')
        .html();
      $(this.$filterable)
        .find('.filterable--results')
        .html(html);
      this.paginate(data.page);
    });
  }

  toggleMenus() {
    const thisClass = this;
    this.$menu.next(':not(.init-open)').hide();
    // eslint-disable-next-line func-names
    this.$menu.on('click', function () {
      const id = $(this).data('filterable-menu');
      const menu = $(this).next();

      $(menu).toggle();

      if ($(menu).is(':visible')) {
        $(this).addClass('open');
        thisClass.addValue('config', id, true);
      } else {
        $(this).removeClass('open');
        thisClass.removeValue('config', id);
      }
    });
  }

  /**
   * checkbox management
   */
  manageCheckboxes() {
    const thisClass = this;
    // eslint-disable-next-line func-names
    this.$filterOptions.on('change', function () {
      /* localStorage */
      const id = $(this).attr('id');
      const val = $(this).is(':checked');

      if (val) {
        thisClass.addValue('valueCheckboxes', id, val);
      } else {
        thisClass.removeValue('valueCheckboxes', id);
      }

      thisClass.apply();
    });
  }

  manageSelectboxes() {
    const thisClass = this;
    // eslint-disable-next-line func-names

    this.$filterSelects.on('change', function () {
      const id = $(this).attr('id');
      const val = $(this).val();

      if (val) {
        thisClass.addValue('valueSelects', id, val);
      } else {
        thisClass.removeValue('valueSelects', id);
      }

      thisClass.apply();
    });
  }

  isValid(data) {
    if (!(data.timestamp instanceof Date)) {
      // console.log('no date');
      return false;
    }

    const timeout = this.timeout * 60 * 1000;
    const timestamp = data.timestamp.getTime();
    const now = new Date().getTime();

    return now - timestamp < timeout;
  }

  setValue(subset, val) {
    const data = this.load();
    data[subset] = val;

    this.save(data);
  }

  addValue(subset, key, val) {
    const data = this.load();

    data[subset][key] = val;

    this.save(data);
    this.setValue('page', 0);
  }

  removeValue(subset, key) {
    const data = this.load();

    if (key in data[subset]) {
      delete data[subset][key];
    }

    this.save(data);
    this.setValue('page', 0);
  }

  paginate(currentPage) {
    this.setValue('page', currentPage);

    const $list = this.$form.find('.filterable--results');
    const $items = $list.find('> div.filterable--result');
    const $paginationIndicator = $(this.$filterable).find('.filterable--pagination-indicator');
    const limit = $paginationIndicator.data('paginate-amount');
    const amount = $items.length;
    const pages = Math.ceil(amount / limit);
    const begin = currentPage * limit;
    const end = begin + limit;

    $paginationIndicator.find('span.begin').text(parseInt(begin, 10) + 1);
    $paginationIndicator.find('span.end').text(amount < end ? amount : end);

    $list.find('.f3-widget-paginator').remove();

    if (pages < 2) {
      return;
    }

    $list.append('<ul class="f3-widget-paginator"></ul>');
    const $paginator = $list.find('.f3-widget-paginator');

    /** create pages */
    for (let i = 0; i < pages; i += 1) {
      if (i === parseInt(currentPage, 10)) {
        $paginator.append(`<li data-page="${i}" class="current"><span>${i + 1}</span></li>`);
      } else {
        $paginator.append(`<li data-page="${i}"><a href="javascript:eval();">${i + 1}</a></li>`);
      }
    }

    /** process items */
    for (let i = 0; i < amount; i += 1) {
      if (i < begin || i >= end) {
        $($items[i]).hide();
      } else {
        $($items[i]).show();
      }
    }

    $paginator.find('a').click(e => {
      this.paginate(
        $(e.currentTarget)
          .parent()
          .data('page'),
      );

      $('html, body').animate(
        {
          scrollTop: $(this.$form).offset().top,
        },
        400,
      );
    });
  }

  reset() {
    this.$form[0].reset();

    const data = this.load();
    data.valueCheckboxes = {};
    data.valueSelects = {};
    this.save(data);

    this.apply();
  }
}

/**
 * INIT
 */
// eslint-disable-next-line func-names
$('[data-filterable]').each(function () {
  const type = $(this).data('filterable');
  new FilterableFilterClass().init(type, this);
});
